// screens/CartScreen.tsx
import React, { useState } from "react";
import { View, Text, TouchableOpacity, ScrollView } from "react-native";
import { MenuItemType } from "../components/shared/types/restaurant.types";
import { getResponsiveSize } from "../components/shared/styles/globalStyles";
import { FlickOColors } from "../components/shared/styles/color";
import { menuScreenStyles as styles } from "../components/shared/styles/styles";
import { RootStackParamList } from "../types/navigation";
import { NavigationProp, RouteProp } from "@react-navigation/native";
import ExpandableText from "../components/shared/component/ExpandableText";
import { QuantityControl } from "../components/QuantityControl";
import { registrationStyles } from "../components/shared/styles/registrationStyles";
import { LocBar } from "../components/layout/LocBar";
import { OrderDetails } from "./OrderTrackingScreen";

export interface CartBillData {
  itemTotal: number;
  distance: string;
  deliveryFee: number;
  originalDeliveryFee: number;
  total: number;
  itemDiscount?: number;
  extraDiscount?: number;
  tax?: number;
}

export interface CartItem extends MenuItemType {
  quantity: number;
  discountedPrice?: number;
}

interface CartItemProps {
  item: CartItem;
  onQuantityChange: (itemId: string, change: number) => void;
}

const CartItem = ({ item, onQuantityChange }: CartItemProps) => (
  <View
    style={[
      styles.cartItemContainer,
      { flexDirection: "row", alignItems: "center" },
    ]}
  >
    <View style={styles.itemDetails}>
      <Text style={styles.itemName}>{item.name}</Text>
      <ExpandableText text={item.description} style={styles.itemDescription} />
    </View>
    <View style={{ width: 120 }}>
      <QuantityControl
        quantity={item.quantity}
        handleAdd={() => onQuantityChange(item.id, 1)}
        handleQuantityChange={(change) => onQuantityChange(item.id, change)}
      />
    </View>
    <View style={styles.priceContainer}>
      <Text style={[styles.price]}>₹{item.price}</Text>
    </View>
  </View>
);

interface BillDetailsProps {
  billData: CartBillData;
}

const BillDetails = ({ billData }: BillDetailsProps) => (
  <View>
    <View style={styles.billContainer}>
      <Text style={styles.billTitle}>Bill Details</Text>
      <View style={styles.billRow}>
        <Text>Item Total</Text>
        <Text>₹{billData.itemTotal}</Text>
      </View>
      <View style={styles.billRow}>
        <Text>Delivery Fee | {billData.distance} kms</Text>
        <View>
          <Text>₹{billData.deliveryFee ?? 0}</Text>
        </View>
      </View>
      <View style={styles.billRow}>
        <Text>Tax</Text>
        <View>
          <Text>₹{billData.tax ?? 0}</Text>
        </View>
      </View>
      {/* Add other bill details */}
      <View style={styles.billTotal}>
        <Text style={styles.totalText}>To Pay</Text>
        <Text style={styles.totalAmount}>₹{billData.total}</Text>
      </View>
    </View>
  </View>
);

interface CartScreenProps {
  route: RouteProp<RootStackParamList, "CartScreen">;
  navigation: NavigationProp<RootStackParamList>;
}

const CartScreen = ({ route, navigation }: CartScreenProps) => {
  const { cartItems } = route.params;
  const [items, setItems] = useState<CartItem[]>(cartItems);

  const handleQuantityChange = (itemId: string, change: number) => {
    setItems((prev) =>
      prev.map((item) =>
        item.id === itemId
          ? { ...item, quantity: Math.max(0, item.quantity + change) }
          : item
      )
    );
  };

  return (
    <View style={styles.container}>
      <LocBar
        hideNav={true}
        user={undefined}
        defaultLocation={undefined}
      ></LocBar>
      <ScrollView>
        <View style={[registrationStyles.card, registrationStyles.cardMargin]}>
          {cartItems.map((item: CartItem) => (
            <CartItem
              key={item.id}
              item={item}
              onQuantityChange={handleQuantityChange}
            />
          ))}
          <TouchableOpacity
            style={[
              styles.menuAddBtn,
              {
                bottom: 0,
                position: "relative",
                marginTop: getResponsiveSize(20),
                marginBottom: getResponsiveSize(10),
              },
            ]}
            onPress={() => navigation.goBack()}
          >
            <Text>Add more items + </Text>
          </TouchableOpacity>
        </View>

        <View style={[registrationStyles.card, registrationStyles.cardMargin]}>
          <BillDetails
            billData={{
              itemTotal: 399,
              distance: "5.5",
              deliveryFee: 107,
              originalDeliveryFee: 127,
              tax: 245,
              total: 645,
            }}
          />
        </View>
        <View style={[styles.billContainer, { backgroundColor: "" }]}>
          <Text style={styles.billTitle}>
            Review your order address details to avoid cancellation
          </Text>
        </View>
      </ScrollView>

      <View style={styles.borderTop}>
        <TouchableOpacity
          style={styles.payButton}
          onPress={() => {
            const orderDetails: OrderDetails = {
              orderId: "174322508967",
              estimatedTime: "33 mins",
              restaurant: {
                name: "Pizza Hut",
                phone: "+918999712275",
              },
              delivery: {
                name: "Kunal Jambwani",
                phone: "+918999712275",
                address: "D202 Aarti Avishkar, kandivali West, 200067",
              },
            };
            navigation.navigate("OrderTrackingScreen", { orderDetails });
          }}
        >
          <Text style={styles.payButtonText}>Order Now ₹645 (COD)</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default CartScreen;
